import { Switch } from "react-router-dom";
import Route from "../Route";
import CompanyRuralEstablishments from "../../pages/componenteserp/qyonbot/empresaestabelecimentosrurais/CompanyRuralEstablishments";

export default function ComponentesErp() {
  return (
    <>
      <Switch>
        <Route
          path="/componenteserp/qyonbot/estabelecimentosrurais"
          component={CompanyRuralEstablishments}
        />
      </Switch>
    </>
  );
}
